import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-more",
  "use": "icon-more-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-more\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M13.5,12A1.5,1.5,0,1,0,12,13.5,1.5,1.5,0,0,0,13.5,12Zm-4,0A1.5,1.5,0,1,0,8,13.5,1.5,1.5,0,0,0,9.5,12Zm8,0A1.5,1.5,0,1,0,16,13.5,1.5,1.5,0,0,0,17.5,12Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol